import { IFileService } from './IFileService';
import { ExportData } from './IDatabaseService';

/**
 * Web/PWA file service adapter
 * Uses HTML5 File API for file operations
 */
export class WebFileAdapter implements IFileService {
  async importJSON(): Promise<ExportData> {
    return new Promise((resolve, reject) => {
      // Create hidden file input element
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = '.json,application/json';
      input.style.display = 'none';

      input.onchange = async (e) => {
        try {
          const file = (e.target as HTMLInputElement).files?.[0];
          if (!file) {
            reject(new Error('No file selected'));
            return;
          }

          // Read file content
          const text = await file.text();

          // Parse JSON
          const data = JSON.parse(text) as ExportData;

          // Clean up
          document.body.removeChild(input);

          resolve(data);
        } catch (error) {
          // Clean up
          document.body.removeChild(input);

          if (error instanceof SyntaxError) {
            reject(new Error('Invalid JSON file'));
          } else {
            reject(error);
          }
        }
      };

      input.oncancel = () => {
        document.body.removeChild(input);
        reject(new Error('Import cancelled'));
      };

      // Add to DOM and trigger click
      document.body.appendChild(input);
      input.click();
    });
  }

  async exportJSON(data: ExportData, filename: string): Promise<void> {
    // Create blob from JSON data
    const jsonString = JSON.stringify(data, null, 2);
    const blob = new Blob([jsonString], {
      type: 'application/json'
    });

    // Create download link
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.style.display = 'none';

    // Add to DOM, trigger download, and clean up
    document.body.appendChild(a);
    a.click();

    // Clean up after a short delay to ensure download starts
    setTimeout(() => {
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }, 100);
  }
}
